globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ResetIcon = function ResetIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2.72656 12.276L6.89323 8.10938",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.72656 1.16602V1.51324",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.72656 3.94488V3.59766",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M4.11285 2.55469H3.76562",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M1.33594 2.55469H1.68316",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.4453 10.8887V11.2359",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.4453 13.6656V13.3184",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13.8394 12.2773H13.4922",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.0547 12.2773H11.4019",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.19531 12.9729L7.5842 11.584",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.03125 8.8049L3.42014 7.41602",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M9.60836 7.81469L9.03426 5.9679L7.18746 5.39382C7.11224 5.37044 7.04506 5.32648 6.99353 5.26691C6.94199 5.20735 6.90814 5.13455 6.89582 5.05675C6.8835 4.97895 6.89319 4.89925 6.9238 4.82667C6.95441 4.75409 7.00472 4.69153 7.06903 4.64605L8.64804 3.52938L8.62335 1.59554C8.62233 1.51677 8.64338 1.4393 8.6841 1.37187C8.72483 1.30444 8.7836 1.24975 8.85379 1.21399C8.92397 1.17822 9.00276 1.16281 9.08125 1.16949C9.15974 1.17617 9.23479 1.20468 9.29792 1.25179L10.8479 2.40846L12.6794 1.78737C12.754 1.76207 12.8342 1.75815 12.9109 1.77605C12.9876 1.79395 13.0578 1.83295 13.1135 1.88865C13.1692 1.94434 13.2082 2.01452 13.2261 2.09122C13.244 2.16793 13.2401 2.24812 13.2148 2.32271L12.5937 4.15424L13.7503 5.70421C13.7975 5.76734 13.826 5.84239 13.8326 5.92088C13.8393 5.99937 13.8239 6.07816 13.7881 6.14834C13.7524 6.21853 13.6977 6.2773 13.6303 6.31803C13.5628 6.35875 13.4854 6.3798 13.4066 6.37878L11.4728 6.35407L10.3561 7.93308C10.3106 7.99739 10.2481 8.04769 10.1755 8.07829C10.1029 8.1089 10.0232 8.11859 9.94544 8.10627C9.86765 8.09396 9.79485 8.06012 9.73528 8.00859C9.67571 7.95706 9.63175 7.8899 9.60836 7.81469Z",
      stroke: "#492983",
      strokeWidth: "1.2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};